export const Logo = ({ className = "w-8 h-8" }) => (
  <img
    src="/logo-emblem.png"
    alt="Piezas Aljarafe 24H"
    className={`${className} object-contain mix-blend-screen`}
  />
);

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
